import { createSelector } from 'reselect';
import { orderBy, values } from 'lodash';

import { fetchAnnotationsActionTypes } from './../actions/types';
import {
  cachedRequestByIdReducer,
  reducerById
} from './helpers';
import {
  annotation as constants,
  utils
} from './../helpers';
import { scenariosById } from './scenarios';

const annotations = cachedRequestByIdReducer(
  fetchAnnotationsActionTypes,
  undefined, // use default
  undefined, // use default
  () => reducerById(fetchAnnotationsActionTypes.success,
    fetchAnnotationsActionTypes.delete)
);
export default annotations;

const getAnnotationsState = state => state.annotations;

export const getAnnotations = createSelector(
  getAnnotationsState,
  (annotations) => values(annotations.byId)
);

export const getAnnotationsByType = createSelector(
  getAnnotations,
  (annotations) => utils.accumulatorReducerByFunc(
    annotations,
    (a) => {
      if (a.scenario_id) return constants.SCENARIO_TYPED;
      if (a.build_id) return constants.BUILD_TYPED;
      if (a.job_id) return constants.JOB_TYPED;
      if (a.app_id) return constants.APP_TYPED;
    },
    (a) => a
  )
);

export const annotationsByScenarioIds = createSelector(
  getAnnotationsByType,
  (annotationsByType) => utils.propertyAccumulatorReducer(
    annotationsByType[constants.SCENARIO_TYPED] || [],
    'scenario_id'
  )
);

export const annotationsByBuildIds = createSelector(
  getAnnotationsByType,
  (annotationsByType) => utils.propertyAccumulatorReducer(
    annotationsByType[constants.BUILD_TYPED] || [],
    'build_id'
  )
);

export const annotationsByAppIds = createSelector(
  getAnnotationsByType,
  (annotationsByType) => utils.propertyAccumulatorReducer(
    annotationsByType[constants.APP_TYPED] || [],
    'app_id'
  )
);

const annotationsByScenarioNames = createSelector(
  getAnnotations,
  scenariosById,
  (annotations, byId) => groupAnnotationsByScenarioName(
    annotations.map(a => {
      const scenario = byId[a.scenario_id];
      return {
        ...a,
        ScenarioName: scenario ? scenario.name : ''
      };
    }))
);
export const groupAnnotationsByScenarioName = (annotations) =>
  utils.propertyAccumulatorReducer(annotations, 'ScenarioName');

export const getAnnotationsHasJiraTicketsByScenarioName = createSelector(
  annotationsByScenarioNames,
  (annotationsByScenarioNames) => values(annotationsByScenarioNames).reduce(
    (result, annotations) => {
      if (annotations.length === 0) {
        return;
      }

      const filteredAnnos = orderBy(
        annotations.filter(a => a.ticket),
        a => a.created_at,
        'desc'
      );
      const tickets = filteredAnnos.reduce((r, a) => r.add(a.ticket), new Set());
      result[annotations[0].ScenarioName] = [...tickets];
      return result;
    }, {}
  )
);


export const getJiraTicketsByScenarioName = (state, name) =>
  getAnnotationsHasJiraTicketsByScenarioName(state)[name] || [];



// WEBPACK FOOTER //
// src/reducers/annotations.js